import React from 'react'
import { Tag } from 'rsuite'
import { Cell } from 'rsuite-table'
import { DEFAULT_STATUS_STYLE, StatusStyle } from '../../../../styles/statusColors'

type RowData = {
  [key: string]: string | boolean
}

type StatusCellProps = {
  rowData?: RowData,
  dataKey: string,
  posDataLabel?: string,
  negDataLabel?: string,
  colorMap?: Record<string, StatusStyle>,
  labelMap?: Record<string, string>,
}

const defaultProps = {
  rowData: undefined,
  colorMap: undefined,
  labelMap: undefined,
}

const activeLabels = ['Active', 'Live', true, 'Yes']

const StatusCell: React.FC<StatusCellProps> = ({
  rowData,
  dataKey,
  posDataLabel,
  negDataLabel,
  colorMap,
  labelMap,
  ...props
}) => {
  const raw = rowData?.[dataKey]
  const label = raw != null ? String(raw) : undefined
  // No status value (e.g. a totals / footer row) → render nothing, no badge.
  if (label == null || label === '') {
    return <Cell {...props} />
  }
  const isActive = activeLabels.includes(raw as string | boolean)
  const style = colorMap?.[label ?? ''] ??
    (isActive ? DEFAULT_STATUS_STYLE.ACTIVE : DEFAULT_STATUS_STYLE.INACTIVE)

  const displayLabel = label != null
    ? labelMap?.[label] ?? (
        colorMap
          ? label.replace(/_/g, ' ')
          : isActive
            ? posDataLabel
            : negDataLabel || label
      )
    : '—'

  return (
    <Cell {...props}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <span
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: style.dot ?? style.background,
          }}
        />
        <Tag style={{ background: style.background, color: style.color }}>
          {displayLabel}
        </Tag>
      </span>
    </Cell>
  )
}

StatusCell.defaultProps = defaultProps

export default StatusCell
